
/**
 * Scrolls up to the position of the query block when a pagination link is clicked.
 *
 * @function slideUpWhenPaginationClicked
 * @return {void}
 */
export const slideUpWhenPaginationClicked = () => {


	const navElements = document.querySelectorAll( 'nav.wp-block-query-pagination' );

	if ( !navElements ) {

		return

	}

	navElements.forEach( ( element ) => {


		const queryBlock = element.closest( '.wp-block-query' )
		if ( !queryBlock ) {

			return

		}
		const observer = new MutationObserver( mutations => {

			mutations.forEach( mutation => {



				if ( mutation.attributeName === 'href' && queryBlock ) {



					const headerHeight = document.querySelector( '.page-header' ).offsetHeight
					const targetPosition = queryBlock.getBoundingClientRect().top + window.pageYOffset
					window.scrollTo( { top: targetPosition - headerHeight, behavior: 'smooth' } )

				}

			} );

		} );

		const config = { attributes: true, subtree: true };


		observer.observe( element, config );


	} )

}
